import { render, staticRenderFns } from "./ExpertProfileSettings.vue?vue&type=template&id=54d21b36&scoped=true"
import script from "./ExpertProfileSettings.vue?vue&type=script&lang=js"
export * from "./ExpertProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./ExpertProfileSettings.vue?vue&type=style&index=0&id=54d21b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d21b36",
  null
  
)

export default component.exports